export interface Relatorio {
  id: string;
  numero: string;
  titulo: string;
  status: 'Processando' | 'Concluído' | 'Erro';
  tipo: string;
  tiposAdicionais: number;
  periodo: string;
  pedidos: string[];
  geradoEm?: string;
  valorEmAberto?: string;
  cnpj?: string;
}

export interface FiltrosRelatorio {
  pesquisa: string;
  unidade: string;
  tipoRelatorio: string;
  statusOperacional: string;
  periodoInicio: string;
  periodoFim: string;
  valorInicio: string;
  valorFim: string;
}

const mockRelatorios: Relatorio[] = [
  {
    id: '1',
    numero: '#105',
    titulo: 'Relatório de vendas',
    status: 'Processando',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310']
  },
  {
    id: '2',
    numero: '#4672',
    titulo: 'Pedido de vendas',
    status: 'Concluído',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 17/03/2026'
  },
  {
    id: '3',
    numero: '#4671',
    titulo: 'Boletos em aberto',
    status: 'Concluído',
    tipo: 'Financeiro',
    tiposAdicionais: 6,
    periodo: 'Período 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 15/03/2026',
    valorEmAberto: 'R$ 34.347,98',
    cnpj: '60.765.823/0001-30'
  },
  {
    id: '4',
    numero: '#4670',
    titulo: 'Encomendas',
    status: 'Concluído',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 15/03/2026'
  },
  {
    id: '5',
    numero: '#4669',
    titulo: 'Pedido de vendas',
    status: 'Concluído',
    tipo: 'Cadastro',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 15/03/2026'
  },
  {
    id: '6',
    numero: '#4668',
    titulo: 'Pedido de vendas',
    status: 'Concluído',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 14/03/2026'
  },
  {
    id: '7',
    numero: '#4668',
    titulo: 'Centro de custo',
    status: 'Concluído',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 13/03/2026'
  },
  {
    id: '8',
    numero: '#105',
    titulo: 'Relatório de vendas',
    status: 'Concluído',
    tipo: 'Gerencial',
    tiposAdicionais: 6,
    periodo: 'Período: 01/01/2026 - 15/03/2026',
    pedidos: ['63009', '16310', '63009', '16310', '63009', '16310'],
    geradoEm: 'Gerado em 18/03/2026'
  }
];

const mockUnidades = [
  { label: 'Matriz - Hospital Israelita Albert Einsten - 60.765.823/0001-30', value: 'Matriz - Hospital Israelita Albert Einsten - 60.765.823/0001-30' }
];

const mockTiposRelatorio = [
  { label: 'Relatório de vendas', value: 'relatorio-vendas' },
  { label: 'Boletos em aberto', value: 'boletos-aberto' },
  { label: 'Financeiro + operacional', value: 'financeiro-operacional' },
  { label: 'Relatório personalizado', value: 'personalizado' }
];

const mockStatusOperacional = [
  { label: 'Em processamento', value: 'Em processamento' },
  { label: 'Concluído', value: 'Concluído' },
  { label: 'Erro', value: 'Erro' }
];

export const relatoriosService = {
  listar: async (): Promise<Relatorio[]> => {
    return new Promise(resolve => setTimeout(() => resolve(mockRelatorios), 500));
  },
  obterUnidades: async () => {
    return new Promise(resolve => setTimeout(() => resolve(mockUnidades), 300));
  },
  obterTiposRelatorio: async () => {
    return new Promise(resolve => setTimeout(() => resolve(mockTiposRelatorio), 300));
  },
  obterStatusOperacional: async () => {
    return new Promise(resolve => setTimeout(() => resolve(mockStatusOperacional), 300));
  },
  gerarRelatorio: async (): Promise<void> => {
    return new Promise(resolve => setTimeout(() => resolve(), 1000));
  },
  baixarArquivo: async (_id: string): Promise<void> => {
    return new Promise(resolve => setTimeout(() => resolve(), 500));
  },
  preVisualizarExcel: async (_id: string): Promise<void> => {
    return new Promise(resolve => setTimeout(() => resolve(), 500));
  }
};
